import { useTranslation } from 'react-i18next';

export const useErrorTranslations = () => {
  const { t } = useTranslation();
  
  return {
    DATE_IS_TOO_OLD: {
      title: t('errors.DATE_IS_TOO_OLD.title'),
      subtitle: t('errors.DATE_IS_TOO_OLD.subtitle'),
    },
    mailNotFound: {
      title: t('errors.mailNotFound.title'),
      subtitle: t('errors.mailNotFound.subtitle'),
    },
    mailNotFoundRecovery: {
      title: t('errors.mailNotFoundRecovery.title'),
      subtitle: t('errors.mailNotFoundRecovery.subtitle'),
    },
    unauthorized: {
      title: t('errors.unauthorized.title'),
      subtitle: t('errors.unauthorized.subtitle'),
    },
    notAuthorized: {
      title: t('errors.notAuthorized.title'),
      subtitle: t('errors.notAuthorized.subtitle'),
    },
    userExists: {
      title: t('errors.userExists.title'),
      subtitle: t('errors.userExists.subtitle'),
    },
    phoneAlreadyUsed: {
      title: t('errors.phoneAlreadyUsed.title'),
      subtitle: t('errors.phoneAlreadyUsed.subtitle'),
    },
    orarioNonDisponibile: {
      title: t('errors.orarioNonDisponibile.title'),
      subtitle: t('errors.orarioNonDisponibile.subtitle'),
    },
    mailAlreadyRegistered: {
      title: t('errors.mailAlreadyRegistered.title'),
      subtitle: t('errors.mailAlreadyRegistered.subtitle'),
    },
    emptyFields: {
      title: t('errors.emptyFields.title'),
      subtitle: t('errors.emptyFields.subtitle'),
    },
    dbError: {
      title: t('errors.dbError.title'),
      subtitle: t('errors.dbError.subtitle'),
    },
    "errore login fb": {
      title: t('errors.erroreLoginFb.title'),
      subtitle: t('errors.erroreLoginFb.subtitle'),
    },
    emailNotFound: {
      title: t('errors.emailNotFound.title'),
      subtitle: t('errors.emailNotFound.subtitle'),
    },
    userNotFound: {
      title: t('errors.userNotFound.title'),
      subtitle: t('errors.userNotFound.subtitle'),
    },
    errorDisabled: {
      title: t('errors.errorDisabled.title'),
      subtitle: t('errors.errorDisabled.subtitle'),
    },
    CAMPI_VUOTI: {
      title: t('errors.CAMPI_VUOTI.title'),
      subtitle: t('errors.CAMPI_VUOTI.subtitle'),
    },
    ERROR_DELETE: {
      title: t('errors.ERROR_DELETE.title'),
      subtitle: t('errors.ERROR_DELETE.subtitle'),
    },
    errorDataInizio: {
      title: t('errors.errorDataInizio.title'),
      subtitle: t('errors.errorDataInizio.subtitle'),
    },
    alreadyHaveOrario: {
      title: t('errors.alreadyHaveOrario.title'),
      subtitle: t('errors.alreadyHaveOrario.subtitle'),
    },
    alreadyHaveChiusura: {
      title: t('errors.alreadyHaveChiusura.title'),
      subtitle: t('errors.alreadyHaveChiusura.subtitle'),
    },
    errorAddOrario: {
      title: t('errors.errorAddOrario.title'),
      subtitle: t('errors.errorAddOrario.subtitle'),
    },
    servizioNotFound: {
      title: t('errors.servizioNotFound.title'),
      subtitle: t('errors.servizioNotFound.subtitle'),
    },
    erroreInserimentoPoltrona: {
      title: t('errors.erroreInserimentoPoltrona.title'),
      subtitle: t('errors.erroreInserimentoPoltrona.subtitle'),
    },
    errorDeleteOrario: {
      title: t('errors.errorDeleteOrario.title'),
      subtitle: t('errors.errorDeleteOrario.subtitle'),
    },
    notYourPoltrona: {
      title: t('errors.notYourPoltrona.title'),
      subtitle: t('errors.notYourPoltrona.subtitle'),
    },
    noServiceFound: {
      title: t('errors.noServiceFound.title'),
      subtitle: t('errors.noServiceFound.subtitle'),
    },
    noPoltroneFound: {
      title: t('errors.noPoltroneFound.title'),
      subtitle: t('errors.noPoltroneFound.subtitle'),
    },
    noPrenFound: {
      title: t('errors.noPrenFound.title'),
      subtitle: t('errors.noPrenFound.subtitle'),
    },
    notYourPren: {
      title: t('errors.notYourPren.title'),
      subtitle: t('errors.notYourPren.subtitle'),
    },
    erroreDisablePren: {
      title: t('errors.erroreDisablePren.title'),
      subtitle: t('errors.erroreDisablePren.subtitle'),
    },
    errorePrenotazione: {
      title: t('errors.errorePrenotazione.title'),
      subtitle: t('errors.errorePrenotazione.subtitle'),
    },
    cannotPrenInThePast: {
      title: t('errors.cannotPrenInThePast.title'),
      subtitle: t('errors.cannotPrenInThePast.subtitle'),
    },
    prenNotFound: {
      title: t('errors.prenNotFound.title'),
      subtitle: t('errors.prenNotFound.subtitle'),
    },
    errorUpdatePren: {
      title: t('errors.errorUpdatePren.title'),
      subtitle: t('errors.errorUpdatePren.subtitle'),
    },
    prenotazioneRifiutata: {
      title: t('errors.prenotazioneRifiutata.title'),
      subtitle: t('errors.prenotazioneRifiutata.subtitle'),
    },
    errorUpdate: {
      title: t('errors.errorUpdate.title'),
      subtitle: t('errors.errorUpdate.subtitle'),
    },
    saloneNotFound: {
      title: t('errors.saloneNotFound.title'),
      subtitle: t('errors.saloneNotFound.subtitle'),
    },
    noMailToSend: {
      title: t('errors.noMailToSend.title'),
      subtitle: t('errors.noMailToSend.subtitle'),
    },
    ERROR_MOD_POLTRONA: {
      title: t('errors.ERROR_MOD_POLTRONA.title'),
      subtitle: t('errors.ERROR_MOD_POLTRONA.subtitle'),
    },
    dataTooOld: {
      title: t('errors.dataTooOld.title'),
      subtitle: t('errors.dataTooOld.subtitle'),
    },
    alreadySet: {
      title: t('errors.alreadySet.title'),
      subtitle: t('errors.alreadySet.subtitle'),
    },
    errorAddLista: {
      title: t('errors.errorAddLista.title'),
      subtitle: t('errors.errorAddLista.subtitle'),
    },
    richiestaNotFound: {
      title: t('errors.richiestaNotFound.title'),
      subtitle: t('errors.richiestaNotFound.subtitle'),
    },
    ERROR_SET_READ_NOTIFY: {
      title: t('errors.ERROR_SET_READ_NOTIFY.title'),
      subtitle: t('errors.ERROR_SET_READ_NOTIFY.subtitle'),
    },
    errorScelta: {
      title: t('errors.errorScelta.title'),
      subtitle: t('errors.errorScelta.subtitle'),
    },
    insufficentCredits: {
      title: t('errors.insufficentCredits.title'),
      subtitle: t('errors.insufficentCredits.subtitle'),
    },
    genericError: {
      title: t('errors.genericError.title'),
      subtitle: t('errors.genericError.subtitle'),
    },
    invalidToken: {
      title: t('errors.invalidToken.title'),
      subtitle: t('errors.invalidToken.subtitle'),
    },
    emptyToken: {
      title: t('errors.emptyToken.title'),
      subtitle: t('errors.emptyToken.subtitle'),
    },
    error: {
      title: t('errors.error.title'),
      subtitle: t('errors.error.subtitle'),
    },
    sessionExpired: {
      title: t('errors.sessionExpired.title'),
      subtitle: t('errors.sessionExpired.subtitle'),
    },
    sessionAlreadyPayed: {
      title: t('errors.sessionAlreadyPayed.title'),
      subtitle: t('errors.sessionAlreadyPayed.subtitle'),
    },
    StripeInvalidRequestError: {
      title: t('errors.StripeInvalidRequestError.title'),
      subtitle: t('errors.StripeInvalidRequestError.subtitle'),
    },
    sessionNotFound: {
      title: t('errors.sessionNotFound.title'),
      subtitle: t('errors.sessionNotFound.subtitle'),
    },
    scadenzaNotUpdated: {
      title: t('errors.scadenzaNotUpdated.title'),
      subtitle: t('errors.scadenzaNotUpdated.subtitle'),
    },
    ERRORE_OLD_PASS: {
      title: t('errors.ERRORE_OLD_PASS.title'),
      subtitle: t('errors.ERRORE_OLD_PASS.subtitle'),
    },
    ERROR_PWD: {
      title: t('errors.ERROR_PWD.title'),
      subtitle: t('errors.ERROR_PWD.subtitle'),
    },
    noUser: {
      title: t('errors.noUser.title'),
      subtitle: t('errors.noUser.subtitle'),
    },
    userDisabled: {
      title: t('errors.userDisabled.title'),
      subtitle: t('errors.userDisabled.subtitle'),
    },
    nMaxPrenotazioniRaggiunto: {
      title: t('errors.nMaxPrenotazioniRaggiunto.title'),
      subtitle: t('errors.nMaxPrenotazioniRaggiunto.subtitle'),
    },
    queueRemoveFailed: {
      title: t('errors.queueRemoveFailed.title'),
      subtitle: t('errors.queueRemoveFailed.subtitle'),
    },
  };
};
